// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-accordion {
    width: 100%;
    position: relative;
    display: block;
    height: 40px;
}

::ng-deep .mat-expansion-panel-content {
    overflow-y: auto !important;
}

mat-radio-group {
    display: flex;
    flex-direction: column;
    margin-left: -15px;
}

mat-expansion-panel {
    background-color: var(--screen-background);
    border: 1px solid var(--text);
    border-radius: 8px !important;
    box-shadow: none !important;
    color: var(--filter);
    background-color: var(--screen-background);
}

mat-expansion-panel-header {
    padding: 0 10px;
    -webkit-tap-highlight-color: transparent;
    background-color: transparent !important;
}

mat-panel-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 0;
    color: var(--text);
}

:host ::ng-deep .modal-panel .mat-expansion-panel-body{
    padding: 0;
}

.option-select{
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 25px;
}


:host ::ng-deep .mat-radio-button .mat-radio-container {
    display: none;
}

:host ::ng-deep .mat-radio-button .mat-radio-label-content {
    padding: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-right: 20px;
}

:host ::ng-deep .mat-radio-checked .mat-radio-label {
    background-color: var(--form-background);
    color: var(--accept-selection);
}

.check-done {
    vertical-align: middle;
    font-size: 20px;
    padding: 5px;
}
/* Abertura para cima quando não há espaço abaixo */
:host.open-upward ::ng-deep mat-expansion-panel {
    border-radius: 0 0 8px 8px !important;
    overflow: visible !important;
}

:host.open-upward ::ng-deep mat-expansion-panel > .mat-expansion-panel-content {
    position: absolute !important;
    bottom: 100% !important;
    top: auto !important;
    left: -1px;
    right: -1px;
    background: var(--screen-background);
    border: 1px solid var(--text);
    border-radius: 8px 8px 0 0;
    box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.12);
    z-index: 5;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/expansion-panel/expansion-panel.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;IAC1C,6BAA6B;IAC7B,6BAA6B;IAC7B,2BAA2B;IAC3B,oBAAoB;IACpB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,wCAAwC;IACxC,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,YAAY;AAChB;AACA,mDAAmD;AACnD;IACI,qCAAqC;IACrC,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,oBAAoB;IACpB,UAAU;IACV,WAAW;IACX,oCAAoC;IACpC,6BAA6B;IAC7B,0BAA0B;IAC1B,0CAA0C;IAC1C,UAAU;AACd","sourcesContent":["mat-accordion {\n    width: 100%;\n    position: relative;\n    display: block;\n    height: 40px;\n}\n\n::ng-deep .mat-expansion-panel-content {\n    overflow-y: auto !important;\n}\n\nmat-radio-group {\n    display: flex;\n    flex-direction: column;\n    margin-left: -15px;\n}\n\nmat-expansion-panel {\n    background-color: var(--screen-background);\n    border: 1px solid var(--text);\n    border-radius: 8px !important;\n    box-shadow: none !important;\n    color: var(--filter);\n    background-color: var(--screen-background);\n}\n\nmat-expansion-panel-header {\n    padding: 0 10px;\n    -webkit-tap-highlight-color: transparent;\n    background-color: transparent !important;\n}\n\nmat-panel-title {\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    padding: 0;\n    color: var(--text);\n}\n\n:host ::ng-deep .modal-panel .mat-expansion-panel-body{\n    padding: 0;\n}\n\n.option-select{\n    padding-top: 5px;\n    padding-bottom: 5px;\n    padding-left: 25px;\n}\n\n\n:host ::ng-deep .mat-radio-button .mat-radio-container {\n    display: none;\n}\n\n:host ::ng-deep .mat-radio-button .mat-radio-label-content {\n    padding: 0;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    padding-right: 20px;\n}\n\n:host ::ng-deep .mat-radio-checked .mat-radio-label {\n    background-color: var(--form-background);\n    color: var(--accept-selection);\n}\n\n.check-done {\n    vertical-align: middle;\n    font-size: 20px;\n    padding: 5px;\n}\n/* Abertura para cima quando não há espaço abaixo */\n:host.open-upward ::ng-deep mat-expansion-panel {\n    border-radius: 0 0 8px 8px !important;\n    overflow: visible !important;\n}\n\n:host.open-upward ::ng-deep mat-expansion-panel > .mat-expansion-panel-content {\n    position: absolute !important;\n    bottom: 100% !important;\n    top: auto !important;\n    left: -1px;\n    right: -1px;\n    background: var(--screen-background);\n    border: 1px solid var(--text);\n    border-radius: 8px 8px 0 0;\n    box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.12);\n    z-index: 5;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
